// import React, {useEffect} from 'react';

// import {PostHogProvider, usePostHog} from 'posthog-js/react';

// import springboard from 'springboard';
// import {serverRegistry} from 'springboard-server/src/register';
// import {useCurrentUser} from '../music_sniper/hooks/useCurrentUser';

// 

// 

// declare module 'springboard/module_registry/module_registry' {
//     interface AllModules {
//         Posthog: PosthogModuleReturnValue;
//     }
// }

// type PosthogModuleReturnValue = {

// };

// springboard.registerModule('Posthog', {}, async (moduleAPI): Promise<PosthogModuleReturnValue> => {
//     if (process.env.NODE_ENV !== 'production') {
//         return {};
//     }

//     return {
//         Provider: (props: React.PropsWithChildren) => {
//             return (
//                 <PostHogProvider
//                     apiKey={'phc_n620KhU9Hs1iUlf66kwX02O3eKTd11pwXCNqmLEDP3H'}
//                     options={{
//                         session_recording: {
//                             maskAllInputs: true,
//                         },
//                         ui_host: process.env.PUBLIC_SITE_URL + '/posthog_ui',
//                         api_host: process.env.PUBLIC_SITE_URL + '/posthog_api',
//                     }}
//                 >
//                     <PostHogInit />
//                     {props.children}
//                 </PostHogProvider>
//             );
//         },
//     };
// });

// const PostHogInit = () => {
//     const posthog = usePostHog();
//     // useEffect(() => {
//     //     posthog.stopSessionRecording();
//     //     setTimeout(() => {
//     //         posthog.startSessionRecording();
//     //     }, 1000);
//     // }, []);

//     const currentUser = useCurrentUser();
//     useEffect(() => {
//         if (currentUser) {
//             posthog.identify(currentUser.id, {
//                 created_at: currentUser.created_at,
//             });
//         }
//     }, [currentUser]);

//     return null;
// }
// 
